import { render, staticRenderFns } from "./fullScreenImg.vue?vue&type=template&id=3bb9c4c8&lang=html&"
import script from "./fullScreenImg.vue?vue&type=script&lang=js&"
export * from "./fullScreenImg.vue?vue&type=script&lang=js&"
import style0 from "./fullScreenImg.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/@nuxtjs/vuetify/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VFadeTransition,VProgressLinear})
